import * as React from "react";
import numeral from "numeral";
import { Trans, useTranslation } from "react-i18next";
import { Alert, Col, Row } from "components/bootstrap";
import { RelativeTime } from "components/common";
import NumberUtils from "util/NumberUtils";
import useDataLakeJournalMetrics from "../hooks/useDataLakeJournalMetrics";
const DataLakeJournal = ({ nodeId }) => {
  const { t } = useTranslation("enterprise_data_lake");
  const metrics = useDataLakeJournalMetrics(nodeId);
  return /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement("h2", null, t("journal.title")), /* @__PURE__ */ React.createElement("p", { className: "description" }, t("journal.description")), Object.keys(metrics).length === 0 ? /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning" }, t("journal.metrics_unavailable")) : /* @__PURE__ */ React.createElement(Row, { className: "row-sm" }, /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement("dl", { className: "system-journal" }, /* @__PURE__ */ React.createElement("dt", null, t("journal.size")), /* @__PURE__ */ React.createElement("dd", null, NumberUtils.formatBytes(metrics.size)), /* @__PURE__ */ React.createElement("dt", null, t("journal.earliest_entry")), /* @__PURE__ */ React.createElement("dd", null, /* @__PURE__ */ React.createElement(RelativeTime, { dateTime: metrics.oldestSegment })))), /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "journal.uncommitted_summary",
      values: { uncommitted: numeral(metrics.messageUncommitted).format("0,0"), segments: metrics.segments },
      components: { bold: /* @__PURE__ */ React.createElement("strong", null) }
    }
  ), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "journal.unflushed_summary",
      values: { unflushed: numeral(metrics.unflushedMessages).format("0,0") },
      components: { bold: /* @__PURE__ */ React.createElement("strong", null) }
    }
  )))));
};
export default DataLakeJournal;
